import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Bedankt for uw bericht! Wij nemen binnen 24 uur contact met u op.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div>
      <section className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Contact</h1>
          <p className="text-xl opacity-90">Neem contact met ons op voor vragen of suggesties</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-2xl font-bold mb-6">Stuur een Bericht</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-gray-700 mb-2">Naam</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                    placeholder="Uw naam"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">E-mail</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                    placeholder="uw@email.nl"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Onderwerp</label>
                  <select
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                  >
                    <option value="">Selecteer een onderwerp</option>
                    <option value="vraag">Algemene vraag</option>
                    <option value="tip">Nieuwstip</option>
                    <option value="feedback">Feedback</option>
                    <option value="samenwerking">Samenwerking</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Bericht</label>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    required
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                    placeholder="Uw bericht..."
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-amber-600 text-white py-3 rounded-lg font-semibold hover:bg-amber-700 transition"
                >
                  Verstuur Bericht
                </button>
              </form>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-6">Contactgegevens</h2>
              <div className="space-y-6">
                <div className="bg-white rounded-xl shadow-md p-6 flex items-start">
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                    <Mail className="w-6 h-6 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1">E-mail</h3>
                    <p className="text-gray-600">info@wkinformatie.nl</p>
                    <p className="text-sm text-gray-500">Reactie binnen 24 uur</p>
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-md p-6 flex items-start">
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                    <Phone className="w-6 h-6 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1">Telefoon</h3>
                    <p className="text-gray-600">085-123 456 78</p>
                    <p className="text-sm text-gray-500">Maandag - Vrijdag: 09:00 - 17:00</p>
                  </div>
                </div>

                <div className="bg-white rounded-xl shadow-md p-6 flex items-start">
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                    <MapPin className="w-6 h-6 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1">Locatie</h3>
                    <p className="text-gray-600">Amsterdam, Nederland</p>
                    <p className="text-sm text-gray-500">Bezoek alleen op afspraak</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;